import { Layout, Modal } from "antd";
import _ from "lodash";
import { KV, doFunction } from "module-reaction";
import { OpportunityApplicants } from "./dashboard_opportunity/opportunity_applicant";
import SchoolDashboardAddStudent from "./school_dashboard_index/school_dashboard_add_student";
import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import CRHeader from "../../components/component_cr_header";
import DashboardSidebar from "../../components/component_dashboard_sidebar";
import {
  router_add_canvas,
  router_add_student,
  router_bookmarks,
  router_bookmarks_all,
  router_notifications,
  router_dashboard_post_job_opp,
  router_membership,
  router_membership_billing_update,
  router_membership_invoice_list,
  router_membership_invoice_view,
  router_membership_plan_update,
  router_my_canvases,
  router_my_dashboard,
  router_opportunity_applicants,
  router_settings,
  router_message,
  router_upgrade_student_canvas,
  router_admin_user,
  TargetType,
  router_admin_school,
  router_admin_opportunity,
  router_admin_canvas,
  router_admin_sms,
  router_admin_featured,
  router_admin_data,
  router_admin_external_payment,
  router_admin_classes
} from "../../utils/enum";
// import { PostJobOpportunity } from "../opportunity/post_job_opp/post_job_opp";
import { Bookmarks } from "./bookmarks/bookmarks";
import { BookmarksAll } from "./bookmarks/bookmarks_all";
import NotificationList from "./notifications/list";
import { mapProp, doAction } from "module-reaction";
import {
  LoginWithTokenAction,
  modle_user,
  LogOutAction,
} from "../../models/model_user";
import { model_dashboad_index } from "../../models/model_dashboard_index";
import { module_notifications } from "../../models/model_notifications";
import "./my_account.less";
import BillingUpdate from "./membership/billing_update";
import { InvoiceList } from "./membership/invoice_list";
import { InvoiceView } from "./membership/invoice_view";
import { MembershipIndex } from "./membership/membership_index";
import { PlanUpdate } from "./membership/plan_update";
import "./my_account.less";
import { AddCanvas } from "./my_canvases/add_canvas";
import { MyCanvas } from "./my_canvases/my_canvas";
import { Message } from "./message/message";
import { module_chat } from "../../models/model_chat";
import { chatClient, initChatClient } from "../../utils/chatHelper";
import { Setting } from "./setting";
import { UpgradeStudentCanvas } from "./upgrade_student_canvas/upgrade_student_canvas";

//admin
import AdminUser from "./admin/user";
import { removeUserDashboardDot } from "../../api/Auth";
import AdminCanvas from "./admin/canvas";
import AdminOpportunity from "./admin/opportunity";
import AdminSchool from "./admin/school";
import DashboardIndex from "./dashboard_index";
import { PostJobOpportunity } from "../opportunity/post_job_opp/post_job_opp";
import GetStartedOverlay from "../onboarding/get_start_overlay";
import { checkOverlay } from "../../utils/utils";
import AdminSms from "./admin/sms";
import AdminFeatured from "./admin/featured";
import AdminData from "./admin/data";
import AdminExternalPayment from "./admin/external";
import RedirectComponent from "../../components/component_redirect";
import { getStaticAssetPath } from "../../utils/utils";
import { getMyAskedOppList } from "../../api/Opportunity";
import {
  canvasFlagsFromList,
  connectMenuItem,
  homeMenuItem,
  myApplicationsMenuItem,
  myBusinessMenuItem,
  placementReportingMenuItem,
  shouldShowMyApplicationsNav,
  shouldShowPlacementReportingNav,
  shouldShowUserDashboardNav,
} from "../../utils/userNavCanvas";
import {
  module_my_canvas,
  GetMyCanvasesAction,
} from "../../models/model_my_canvas";
const { Content } = Layout;

interface MyAccountProps extends RouteComponentProps, KV {
  match: any;
}

/** Routes for /my-account: user routes first so shared paths (e.g. message) match app-wide behavior */
function mergeAdminAndUserRoutes(
  userRoutes: any[],
  adminRoutes: any[]
): any[] {
  const seen = new Set<string>();
  const out: any[] = [];
  for (const r of userRoutes) {
    if (r.path != null && !seen.has(r.path)) {
      seen.add(r.path);
      out.push(r);
    }
  }
  for (const r of adminRoutes) {
    if (r.path != null && !seen.has(r.path)) {
      seen.add(r.path);
      out.push(r);
    }
  }
  return out;
}

@mapProp(modle_user)
@mapProp(module_chat)
@mapProp(module_notifications, "notificationCount")
@mapProp(model_dashboad_index)
@mapProp(module_my_canvas, "canvasList")
export default class MyAccount extends React.Component<MyAccountProps, {}> {
  state = {
    getStartedOverlay: false,
    hasApplications: false,
  }

  componentRouters: any[] = [
    {
      name: "Account Settings",
      path: router_settings,
      component: Setting,
      exact: true,
    },
    // {
    //   name: "Membership",
    //   path: router_membership,
    //   component: () => <MembershipIndex {...this.props} />,
    //   exact: true,
    // },
    {
      name: "Invoices",
      path: router_membership_invoice_list,
      component: () => <InvoiceList {...this.props} title="Payment History" />,
      exact: true,
      hideFromMenu: true,
    },
    {
      name: "Invoice Details",
      path: router_membership_invoice_view,
      component: () => <InvoiceView {...this.props} title="Invoice Details" />,
      exact: true,
      hideFromMenu: true,
    },
    {
      name: "Billing Update",
      path: router_membership_billing_update,
      component: () => (
        <BillingUpdate {...this.props} title="Billing Information" />
      ),
      exact: true,
      hideFromMenu: true,
    },
    {
      name: "Plan Update",
      path: router_membership_plan_update,
      component: () => (
        <PlanUpdate {...this.props} title="Change Canvas Plan" />
      ),
      exact: true,
      hideFromMenu: true,
    },
    {
      name: "Notifications",
      path: router_notifications,
      component: NotificationList,
      exact: true,
    },
    {
      name: "Message",
      path: router_message,
      component: () => <RedirectComponent url={`${process.env.REACT_APP_NEXT_URL}/message`} />,
      exact: true,
    },
    {
      name: "Bookmarks",
      path: router_bookmarks,
      component: Bookmarks,
      exact: true,
    },
    {
      name: "Bookmarks",
      path: router_bookmarks_all,
      component: BookmarksAll,
      hide: true,
    },
    {
      name: "My Portfolio",
      path: router_my_canvases,
      component: () => <RedirectComponent url={`${process.env.REACT_APP_NEXT_URL}/portfolio`} />,
      exact: true,
    },
    {
      name: "My Portfolio",
      path: router_add_canvas,
      component: AddCanvas,
      hide: true,
    },
    {
      name: "My Portfolio",
      path: router_upgrade_student_canvas,
      component: UpgradeStudentCanvas,
      hide: true,
    },
    {
      name: "My Dashboard",
      path: router_my_dashboard,
      component: DashboardIndex,
    },
    {
      name: "My Portfolio",
      path: router_add_student,
      component: SchoolDashboardAddStudent,
      hide: true,
    },
    {
      name: "My Dashboard",
      path: router_opportunity_applicants,
      component: () => (
        <OpportunityApplicants
          match={this.props.match}
          history={this.props.history}
        ></OpportunityApplicants>
      ),
      hide: true,
    },
    {
      name: "My Dashboard",
      path: router_dashboard_post_job_opp,
      component: PostJobOpportunity,
      hide: true,
    },
    {
      ...homeMenuItem(),
    },
  ];

  adminMenuItem = [
    // {
    //   name: "Send SMS",
    //   path: router_admin_sms,
    //   component: AdminSms,
    //   exact: true,
    // },
    {
      name: "Notifications",
      path: router_notifications,
      component: NotificationList,
      exact: true,
    },
    {
      name: "Message",
      path: router_message,
      component: Message,
      exact: true,
    },
    {
      name: "KPI Dashboard",
      path: router_admin_data,
      component: AdminData,
      exact: true,
    },
    {
      name: "Class Metrics",
      path: router_admin_classes,
      component: () => <RedirectComponent url={`${process.env.REACT_APP_NEXT_URL}/admin/classes`} />,
      exact: true,
    },
    {
      name: "External Payment",
      path: router_admin_external_payment,
      component: () => <RedirectComponent url={`${process.env.REACT_APP_NEXT_URL}/admin/external`} />,
      exact: true,
    },
    {
      name: "School Dashboard",
      path: router_admin_school,
      component: AdminSchool,
      exact: true,
      // Prefer Next; keep React route for direct /admin-school access
      externalHref: `${process.env.REACT_APP_NEXT_URL}/admin/school`,
    },
    {
      name: "Canvas Dashboard",
      path: router_admin_canvas,
      component: AdminCanvas,
      exact: true,
      // Prefer Next; keep React route for direct /admin-canvas access
      externalHref: `${process.env.REACT_APP_NEXT_URL}/admin/canvas`,
    },
    {
      name: "Opportunity Dashboard",
      path: router_admin_opportunity,
      component: AdminOpportunity,
      exact: true,
      // Prefer Next; keep React route for direct /admin-opportunity access
      externalHref: `${process.env.REACT_APP_NEXT_URL}/admin/opportunity`,
    },
    {
      name: "My Users",
      path: router_admin_user,
      component: () => <RedirectComponent url={`${process.env.REACT_APP_NEXT_URL}/admin/users`} />,
      exact: true,
    }
  ];

  private getMergedRouteList(): any[] {
    return mergeAdminAndUserRoutes(this.componentRouters, this.adminMenuItem);
  }

  /** Sidebar for admins: same user destinations as non-admins, then admin tools */
  private getAdminSidebarMenuList(): any[] {
    const userPathOrder = [
      homeMenuItem().path,
      router_my_dashboard,
      router_my_canvases,
      router_bookmarks,
      router_message,
      router_notifications,
      router_settings,
    ];
    const userPaths = new Set(userPathOrder);
    const userItems = userPathOrder
      .map((p) =>
        this.componentRouters.find((r) => r.path === p && !r.hideFromMenu)
      )
      .filter(Boolean);
    const adminItems = this.adminMenuItem.filter((r) => !userPaths.has(r.path));
    return [...userItems, ...adminItems];
  }

  private applyCanvasMenuRules(
    menuList: any[],
    canvasList: any[] = [],
    hasApplications: boolean = false
  ) {
    const { hasSchoolCanvas, hasBusinessCanvas } = canvasFlagsFromList(canvasList);
    let list = menuList.filter(
      (item) =>
        item.path !== router_my_dashboard ||
        shouldShowUserDashboardNav(hasSchoolCanvas)
    );
    const applicationsItem = myApplicationsMenuItem();
    list = list.filter((item) => item.path !== applicationsItem.path);
    if (shouldShowMyApplicationsNav(hasSchoolCanvas, hasApplications)) {
      const homeIndex = list.findIndex((item) => item.path === homeMenuItem().path);
      if (homeIndex >= 0) {
        list.splice(homeIndex + 1, 0, applicationsItem);
      } else {
        list.unshift(applicationsItem);
      }
    }
    if (hasBusinessCanvas) {
      const dashboardIndex = list.findIndex(
        (item) => item.path === router_my_dashboard
      );
      const businessItem = myBusinessMenuItem();
      if (dashboardIndex >= 0) {
        list.splice(dashboardIndex + 1, 0, businessItem);
      } else {
        const homeIndex = list.findIndex((item) => item.path === homeMenuItem().path);
        if (homeIndex >= 0) {
          list.splice(homeIndex + 1, 0, businessItem);
        } else {
          list.unshift(businessItem);
        }
      }
    }
    const placementItem = placementReportingMenuItem();
    list = list.filter((item) => item.path !== placementItem.path);
    if (shouldShowPlacementReportingNav(hasSchoolCanvas)) {
      const portfolioIndex = list.findIndex(
        (item) => item.path === router_my_canvases
      );
      if (portfolioIndex >= 0) {
        list.splice(portfolioIndex, 0, placementItem);
      } else {
        const dashboardIndex = list.findIndex(
          (item) => item.path === router_my_dashboard
        );
        if (dashboardIndex >= 0) {
          list.splice(dashboardIndex + 1, 0, placementItem);
        }
      }
    }
    const homeItem = homeMenuItem();
    list = [
      ...list.filter(
        (item) => item.path !== homeItem.path && item.name !== "Home"
      ),
      homeItem,
    ];
    const connectItem = connectMenuItem();
    list = [
      connectItem,
      ...list.filter(
        (item) =>
          item.path !== connectItem.path && item.name !== "Community"
      ),
    ];
    return list;
  }

  private refreshHasApplications = async () => {
    const { hasSchoolCanvas } = canvasFlagsFromList(this.props.canvasList || []);
    if (hasSchoolCanvas) {
      this.setState({ hasApplications: false });
      return;
    }
    try {
      const applications = await getMyAskedOppList();
      this.setState({
        hasApplications: Array.isArray(applications) && applications.length > 0,
      });
    } catch {
      this.setState({ hasApplications: false });
    }
  };

  componentDidMount() {
    // if (!this.props.curUser.profile) {
    // doAction(LoginWithTokenAction);
    // }
    // fresh userinfo each time enter this page
    // console.log("fresh user info")
    doAction(LoginWithTokenAction);
    doAction(GetMyCanvasesAction);
    this.refreshHasApplications();
    doFunction(async () => {
      if (!chatClient) {
        await initChatClient(this.props.curUser);
      }
    });

    if (checkOverlay()) {
      this.setState({ getStartedOverlay: true });
    }
  }

  componentDidUpdate(prevProps: MyAccountProps) {
    if (prevProps.canvasList !== this.props.canvasList) {
      this.refreshHasApplications();
    }
  }

  componentWillUnmount() {
    if (this.props.location.pathname === router_my_dashboard) {
      // remove user dashboard red-dot
      // console.log("fresh user info2")
      if (this.props.curUser?.role?.value === 'end_user') {
        removeUserDashboardDot().then(data => {
          doAction(LoginWithTokenAction)
        })
      }
    }
  }

  private jumpToLoginPage = () => {
    this.props.history.push({
      pathname: "/sign-in",
      search: `?from=${window.location.pathname}`,
    });
  };

  render() {
    const bgImage = getStaticAssetPath('images/dashboard-bg-2x.png');
    const target =
      this.props.curUser &&
      this.props.curUser.profile &&
      this.props.curUser.profile.target;
    const pathname = this.props.location.pathname;
    /** Legacy admin users use profile.target === admin. Also allow full role + direct /admin-* URLs so provisioned admins and role-based admins get Switch routes (otherwise /admin-school renders blank). */
    const roleVal = this.props.curUser?.role?.value;
    const isRoleAdmin =
      roleVal === "administrator" ||
      roleVal === "super_admin" ||
      Boolean(this.props.curUser?.role?.isSuperAdmin);
    const isAdminDashboardPath =
      pathname.startsWith("/admin-") || pathname === "/admin/redirect";
    const impersonating = Boolean(this.props.curUser?.adminBehalf);
    // Impersonation: use the impersonated user's nav/routes only (header still shows "Back to admin").
    const showAdminExperience =
      target === TargetType.ADMIN ||
      isRoleAdmin ||
      (!impersonating && isAdminDashboardPath);
    const list = showAdminExperience
      ? this.getMergedRouteList()
      : this.componentRouters;
    let menuList: any[];
    if (showAdminExperience) {
      menuList = this.getAdminSidebarMenuList();
    } else {
      menuList = list.slice(0, list.length);
      const removeList = [];
      // Remove submenu from side menu
      for (var i = 0; i < menuList.length; i++) {
        if (menuList[i].hideFromMenu) {
          removeList.push(i);
        }
      }
      for (var j = removeList.length - 1; j >= 0; j--) {
        menuList.splice(removeList[j], 1);
      }
    }
    menuList = this.applyCanvasMenuRules(
      menuList,
      this.props.canvasList || [],
      this.state.hasApplications
    );
    const { getStartedOverlay } = this.state;

    const cur = _.find(list, (item) => {
      return pathname.indexOf(item.path) > -1;
    });
    let curTab = (cur && cur.name) || "";
    return (
      <Layout className="home-root">
        <CRHeader
          className="home-header"
          history={this.props.history}
          onLogin={() => this.jumpToLoginPage()}
          onLogout={() => {
            doAction(LogOutAction);
            doFunction(async () => {
              this.props.history.push("/");
            });
          }}
        />
        <Content className="dashboard-content-wrap" style={{ backgroundImage: `url(${bgImage}) !important` }}>
          <DashboardSidebar
            dashboardDot={this.props.curUser?.profile?.dashboardDot}
            notificationCount={this.props.notificationCount}
            sidebarList={menuList}
            curTab={curTab}
            unreadCount={this.props.unreadCount}
          />
          <div className="dashboard-content">
            <div className="dashboard-route-wrap">
              <Switch>
                {list.map((_: any, idx: number) => (
                  <Route
                    key={`${_.path}-${idx}`}
                    path={_.path}
                    component={_.component}
                    exact={_.exact || false}
                  />
                ))}
              </Switch>
            </div>
          </div>
        </Content>

        <Modal visible={getStartedOverlay}
          closable={true}
          onCancel={() => this.setState({ getStartedOverlay: false })}
          maskClosable={true}
          footer={null}
          centered={true}>
          <GetStartedOverlay type={'school'} close={() => this.setState({ getStartedOverlay: false })}></GetStartedOverlay>
        </Modal>

      </Layout>
    );
  }
}

